import React, { useState } from 'react';
import { DataContext } from '../components/Data/Data.jsx';

// Este é o nosso componente provedor, que contém a lógica de estado
export function DataProvider({ children }) {
  const data = new Date();
  
  // Agora usamos a mesma referência 'data' para extrair as propriedades
  const dia = data.getDate().toString().padStart(2, '0');
  const mes = (data.getMonth() + 1).toString().padStart(2, '0');
  const ano = data.getFullYear();
  const dataFormatada = `${ano}/${mes}/${dia}`;

  // Criamos as variáveis para a nova propriedade 'primAnoMesDia'
  const primMes = (data.getMonth() + 1).toString().padStart(2, '0');
  const primDia = '01'; // O dia é fixo como '01'
  const primAnoMesDia = `${ano}/${primMes}/${primDia}`;
  const dataF = `${ano}-${primMes}-${primDia}`;
  const dataI = `${ano}-${mes}-${dia}`;

  const [dataAtual, setDataAtual] = useState({
    data: data,
    dia: dia,
    mes: mes,
    ano: ano,
    atualAnoMesDia: dataFormatada,
    primAnoMesDia: primAnoMesDia,
    dataInicio: dataI,
    dataFim: dataF
  });

  return (
    // O valor 'dataAtual' agora está disponível para os componentes filhos
    <DataContext.Provider value={dataAtual}>
      {children}
    </DataContext.Provider>
  );
}